module.exports = __webpack_public_path__ + "img/check-on.a08fa822.png";